// Utilities
import { createSimpleFunctional } from "../../util/index.mjs";
export const VCardTitle = createSimpleFunctional('v-card-title');
//# sourceMappingURL=VCardTitle.mjs.map